import React from 'react'
import type { FeedItem } from '../../../Api'
import { AdditionalHeadlinesCon } from './styles'
import { FeedItemRow } from '../FeedItemRow'

type HeadlinesProps = {
  feedItems: FeedItem[]
}

export const AdditionalHeadlines: React.FC<React.PropsWithChildren<HeadlinesProps>> = ({
  feedItems,
}) => {
  return (
    <AdditionalHeadlinesCon>
      {feedItems.map((itm) => (
        <FeedItemRow key={itm.id} feedItem={itm} section={'headlines'} />
      ))}
    </AdditionalHeadlinesCon>
  )
}
